import React, {useEffect} from "react";
import Footer from "../../components/app/footer";
import Header from "../../components/app/header";

export default function ErrorPage() {
    useEffect(() => {
        document.title = "Client Error - Hoarfroster";
    }, []);

    return (
        <>
            <Header/>
            <main>
                <div className="container">
                    <h1>An Error was Occurred.</h1>
                    <p>DAMN PENGUIN HAS DONE SOMETHING WRONG WITH ERROR HANDLING.</p>
                </div>
            </main>
            <Footer/>
        </>
    );
}